import { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface WriteAccessGuardProps {
  page: string;
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Component that only renders children if the user has write access to the specified page.
 * Useful for conditionally showing edit buttons, forms, and other write operations.
 * 
 * @example
 * <WriteAccessGuard page="customers">
 *   <Button onClick={handleEdit}>Edit Customer</Button>
 * </WriteAccessGuard>
 */
export function WriteAccessGuard({ page, children, fallback = null }: WriteAccessGuardProps) {
  const { hasWriteAccess } = useAuth();
  
  if (hasWriteAccess(page)) {
    return <>{children}</>;
  }
  
  return <>{fallback}</>;
}














